import { CreditScore } from '../gql/generated/graphql';
import { creditScores } from './paymentCalculator';

export const getCreditScore = (score: number): CreditScore => {
  const creditScore = creditScores.find((s) => s.min <= score && s.max >= score);
  return creditScore ? creditScore.name : CreditScore.Good;
};
